import { DhlAutocompleteField as NewAutoCompleteField } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for AutoCompleteField component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const AutoCompleteField = (props) => {
  const {
    id,
    dataTestid,
    disabled,
    onChange,
    onOptionSelected,
    value,
    customFilter,
    children,
    ...rest
  } = props;

  const newProps = {
    ...rest,
    id,
    "data-testid": dataTestid,
    isDisabled: disabled,
    inputEvent: onChange,
    optionSelected: onOptionSelected,
    value,
    filter: customFilter,
    openOnFocus: true,
  };

  return <NewAutoCompleteField {...newProps}>{children}</NewAutoCompleteField>;
};

AutoCompleteField.propTypes = {
  id: PropTypes.string.isRequired,
  dataTestid: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onOptionSelected: PropTypes.func,
  value: PropTypes.any,
  customFilter: PropTypes.func,
  children: PropTypes.node,
};
